import { PORTAL_NAME_MODAL_DEFINE } from 'components/common/PortalModal/config';
import usePaytoStore from 'features/to/hooks/payment/usePaytoStore';
import AuthorisePaytoAccountModal from 'features/to/modals/AuthorisePaytoAccountModal';
import usePortalModal from 'hooks/usePortalModal';
import React from 'react';
import withPaytoAgreementProcessing from './withPaytoAgreementProcessing';

const withAuthorisePaytoAccount = (Component) => {
  const AuthorisePaytoAccountComponent = withPaytoAgreementProcessing(
    (props) => {
      const { onAddPaytoAccountAuthorise, onUpdatePaytoAccountAuthorise } =
        props || {};

      const { portalModal } = usePaytoStore();
      const { showPortalModalName } = usePortalModal();

      const onShowAuthorisePaytoAccountModal = (modalOptions) => {
        showPortalModalName({
          name: PORTAL_NAME_MODAL_DEFINE.AUTHORISE_PAYTO_ACCOUNT_MODAL,
          modalOptions,
        });
      };

      const isShowAuthorisePaytoAccountModal =
        portalModal?.name ===
        PORTAL_NAME_MODAL_DEFINE.AUTHORISE_PAYTO_ACCOUNT_MODAL;

      const renderAuthorisePaytoAccountModal = () => {
        if (!isShowAuthorisePaytoAccountModal) return null;
        return (
          <AuthorisePaytoAccountModal
            isShow={isShowAuthorisePaytoAccountModal}
          />
        );
      };

      const newProps = {
        ...props,
        onShowAuthorisePaytoAccountModal,
        onAddPaytoAccountAuthorise,
        onUpdatePaytoAccountAuthorise,
      };
      return (
        <>
          <Component {...newProps} />
          {renderAuthorisePaytoAccountModal()}
        </>
      );
    }
  );
  return AuthorisePaytoAccountComponent;
};

export default withAuthorisePaytoAccount;
